// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multi-select[data-v-1fa9eca7]  .el-tag__close.el-icon-close {\n  right: -4px;\n}\n", ""]);
// Exports
module.exports = exports;
